


























































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { adminList, adminDelete } from "@/api/user";
import { allRole } from "@/api/admin";
import { Role } from "@/types/api/admin";
import { User } from "@/types/api/user";
import copy from "@/utils/deepCopy";
// 混入
import Loading from "@/mixins/loading";
import TablePagination from "@/mixins/tablePagination";

@Component
export default class Header extends Mixins(Loading, TablePagination) {
  @Prop([String]) private keyword!: string;
  tableData: Array<User> = [];

  /**
   * methods
   */
  getData() {
    this.showLoading();
    adminList({
      keyword: this.keyword,
      pageSize: this.pageSize,
      pageNum: this.currentPage,
    }).then((res: any) => {
      res.data.list.forEach((e: any) => {
        e.status = e.status == 0 ? false : true;
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
    });
  }
  // 删除
  handleDelete(row: User) {
    this.$confirm(`是否要删除该用户（编号${row.id}） ?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      adminDelete({
        id: row.id,
      }).then((res: any) => {
        this.getData();
        this.$message.success("删除成功");
      });
    });
  }
}
